import React from "react";
import IconTransportBus from "../../assets/icons/IconTransportBus";
import IconTransportFerry from "../../assets/icons/IconTransportFerry";
import IconTransportTrain from "../../assets/icons/IconTransportTrain";
const IconTransportMode = ({ type, ...props }) => {
  switch (type) {
    case "train":
      return /* @__PURE__ */ React.createElement(IconTransportTrain, {
        ...props
      });
    case "bus":
      return /* @__PURE__ */ React.createElement(IconTransportBus, {
        ...props
      });
    case "ferry":
      return /* @__PURE__ */ React.createElement(IconTransportFerry, {
        ...props
      });
    default:
      return null;
  }
};
var IconTransportMode_default = IconTransportMode;
export {
  IconTransportMode_default as default
};
